module.exports = __webpack_public_path__ + "static/media/airplane.8868bcc4.svg";